// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicProfileSavephoneRequest,
  TPublicProfileSavephoneModel,
  IMappers,
  TPublicProfileSavephoneResponse,
  TPublicProfileSavephoneResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createPublicProfileSavephoneModel(
  parameters: TPublicProfileSavephoneRequest,
): TPublicProfileSavephoneModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'POST',
    microserviceName: 'monolith-cian-profileapi',
    pathApi: '/profile/savephone/',
    response: {
      200: {},
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicProfileSavephoneOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: TPublicProfileSavephoneRequest;
}

export async function fetchPublicProfileSavephone<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicProfileSavephoneOptions<TResponse200>): Promise<
  FetchResponse<TPublicProfileSavephoneResponse> | TResponse200
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicProfileSavephoneModel(parameters),
    config,
  )) as FetchResponse<TPublicProfileSavephoneResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicProfileSavephoneResponseData200, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicProfileSavephoneResponse>;
}
